import { render, staticRenderFns } from "./touch.vue?vue&type=template&id=00cfc3e6"
import script from "./touch.vue?vue&type=script&lang=js"
export * from "./touch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports